import { useShippingSettings } from '@invivodf/common/src/contexts/logistic-offer/application/composables'
import { Ref } from 'vue'

export const useParameterToggles = (roles: Ref<string[]>) => {
  const shippingSettings = useShippingSettings(roles)

  const toggles = [shippingSettings]

  const init = async () => {
    await Promise.all(toggles.map((toggle) => toggle.init()))
  }

  return { init, toggles }
}
